export default __webpack_public_path__ + "static/media/ceoLanding03.27ce0848.png";